import React, { useState, useEffect, Fragment } from 'react';

import { Form } from 'react-final-form';
import {
  useDataProvider,
  useRefresh,
  useNotify,
  required,
  cacheDataProviderProxy,
} from 'react-admin';
import { useStyles } from '../modal.styles';
import { SaveButton } from '../../../../design';
import { DialogActions, DialogContent } from '@material-ui/core';
import clsx from 'clsx';
import {
  ReferenceInput,
  SwitchInput,
  FormTextField,
  handleNumbers,
  getDateInputValue,
} from '.';
export const UserCoverage = ({ handleClose, isEdit, record }) => {
  const classes = useStyles();
  const refresh = useRefresh();
  const dataProvider = cacheDataProviderProxy(useDataProvider());
  const notify = useNotify();
  const [formData, setFormData] = useState({
    is_active: true,
    no_tasks: false,
  });

  useEffect(() => {
    if (isEdit && record) {
      setFormData(f => ({
        is_active: !record.inactive,
        ...record,
      }));
    }
  }, [isEdit, record]);

  const getPayload = value => ({
    ...value,
    purpose: value.purpose?.trim() || null,
    inactive: !value.is_active ? 1 : 0,
  });

  const onSubmit = value => {
    if (isEdit) {
      return dataProvider
        .update('user-coverage', {
          id: record.id,
          data: {
            ...getPayload(value),
          },
          previousData: { ...record },
        })
        .then(({ data }) => {
          notify('form.updated');
          handleClose();
          refresh();
        })
        .catch(error =>
          notify(
            typeof error === 'string'
              ? error
              : error.message || 'ra.notification.http_error',
            'warning',
          ),
        );
    } else {
      return dataProvider
        .create('user-coverage', {
          data: {
            ...getPayload(value),
          },
        })
        .then(({ data }) => {
          notify('form.created');
          handleClose();
          refresh();
        })
        .catch(error =>
          notify(
            typeof error === 'string'
              ? error
              : error.message || 'ra.notification.http_error',
            'warning',
          ),
        );
    }
  };
  const customOnChange = async (eventOrValue, _name, type) => {
    // when using a react-admin input, onChange returns
    // the value instead of the target.
    let value = eventOrValue;
    let name = _name;
    if (typeof eventOrValue === 'object') {
      const target = eventOrValue.target;
      value = target.type === 'checkbox' ? target.checked : target.value;
      name = target.name;
    }
    if (type === 'number') {
      value = handleNumbers(value);
    }
    if (type === 'date') {
      value = getDateInputValue(value);
    }

    setFormData({ ...formData, [name]: value });
  };

  return (
    <Fragment>
      <Form
        onSubmit={onSubmit}
        initialValues={{
          ...formData,
        }}
        render={({
          submitError,
          handleSubmit,
          submitting,
          pristine,
          values,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <div className={clsx(classes.inputContainerWrap)}>
                  <ReferenceInput
                    customOnChange={customOnChange}
                    label='User'
                    name='user_id'
                    validate={required()}
                    required
                    reference='facility-users/list'
                    fullWidth
                    perPage={500}
                    options={{
                      filter: {
                        all_facilities: true,
                        is_active: true,
                        all_roles: true,
                      },
                    }}
                  />
                </div>
                <div className={clsx(classes.inputContainerWrap)}>
                  <ReferenceInput
                    key={formData.user_id}
                    customOnChange={customOnChange}
                    label='Covering for'
                    name='covered_user_id'
                    validate={required()}
                    required
                    reference='facility-users/list'
                    fullWidth
                    perPage={500}
                    options={{
                      filter: {
                        covering_user_id: formData.user_id,
                        all_facilities: true,
                        is_active: true,
                        all_roles: true,
                      },
                    }}
                  />
                </div>

                <div className={clsx(classes.inputContainerWrap)}>
                  <FormTextField
                    name='purpose'
                    label='Purpose'
                    fullWidth
                    customOnChange={customOnChange}
                  />
                </div>

                <div className={clsx(classes.inputContainerWrap)}>
                  <SwitchInput
                    name='is_active'
                    customOnChange={customOnChange}
                    label={formData.is_active ? 'Active' : 'Inactive'}
                    checked={formData.is_active}
                  />
                </div>

                <div className={clsx(classes.inputContainerWrap)}>
                  <SwitchInput
                    name='no_tasks'
                    customOnChange={customOnChange}
                    label={formData.no_tasks ? 'No Tasks' : 'Tasks Allowed'}
                    checked={formData.no_tasks}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <SaveButton
                  // onClick={handleClose}
                  className={classes.saveButton}
                  disabled={submitting}
                  type='submit'
                />
              </DialogActions>
            </form>
          );
        }}
      />
    </Fragment>
  );
};
